'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SwatchPickerRow", {
    enumerable: true,
    get: function() {
        return SwatchPickerRow;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useSwatchPickerRow = require("./useSwatchPickerRow");
const _renderSwatchPickerRow = require("./renderSwatchPickerRow");
const _useSwatchPickerRowStylesstyles = require("./useSwatchPickerRowStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const SwatchPickerRow = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSwatchPickerRow.useSwatchPickerRow_unstable)(props, ref);
    (0, _useSwatchPickerRowStylesstyles.useSwatchPickerRowStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useSwatchPickerRowStyles_unstable')(state);
    return (0, _renderSwatchPickerRow.renderSwatchPickerRow_unstable)(state);
});
SwatchPickerRow.displayName = 'SwatchPickerRow';
